import {useState} from "react";
import {css} from "@emotion/css";
import {MagazineWriterService} from "../../serverService/magazineService/MagazineWriterService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMobileInputOutlined,
    RaikoSimpleInputOutlined,
    RaikoNumberInputOutlined,
    RaikoButtonPrimary, RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";

export default function AddNewWriter({addNewWriterToPreviewList}) {

    const service = new MagazineWriterService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    function handleCreateNewWriter() {
        if (checkFields()) {
            loading.show()
            service.createNewWriter(
                firstName,
                lastName,
                nationalCode,
                phoneNumber
            ).then(response => {
                snackbar.showSuccessMessage("نویسنده ی جدید با موفقیت افزوده شد.")
                addNewWriterToPreviewList(response)
            }).catch(reason => {
                snackbar.showServerErrorMessage(reason)
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let message = ""
        let state = false

        if (firstName.trim().length === 0)
            message = "لطفا نام نویسنده را به درستی وارد نمایید."
        else if (lastName.trim().length === 0)
            message = "لطفا نام خانوادگی نویسنده را به درستی وارد نمایید."
        else if (phoneNumber.trim().length !== 11)
            message = "لطفا شماره همراه نویسنده را به درستی وارد نمایید."
        else if (nationalCode.trim().length < 8)
            message = "لطفا کد ملی نویسنده را به درستی وارد نمایید."
        else
            state = true

        if (message.length > 0)
            snackbar.showWarningMessage(message)
        return state
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 .5rem 1rem .5rem`}>

            <RaikoGridTwoColumn>
                <RaikoSimpleInputOutlined labelText={"نام"} setValue={setFirstName} value={firstName}/>
                <RaikoSimpleInputOutlined labelText={"نام خانوادگی"} setValue={setLastName} value={lastName}/>
                <RaikoNumberInputOutlined labelText={"کد ملی"} setValue={setNationalCode} value={nationalCode}/>
                <RaikoMobileInputOutlined labelText={"شماره همراه"} setValue={setPhoneNumber} value={phoneNumber}/>
            </RaikoGridTwoColumn>

            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={"افزودن"} onClick={handleCreateNewWriter}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}
